import { render } from "./CalendarExercise.vue?vue&type=template&id=2c5d5ca6"
import script from "./CalendarExercise.vue?vue&type=script&lang=js"
export * from "./CalendarExercise.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__